module.exports = __webpack_public_path__ + "static/img/nodata.d2c75c40.png";